/* eslint-disable class-methods-use-this */
import requireAll from "../utils/require-all";
var SVGLoader = /** @class */ (function () {
    function SVGLoader(url, loadIcons) {
        if (loadIcons === void 0) { loadIcons = true; }
        this.svgUrl = url;
        if (loadIcons) {
            this.loadSpriteIcons();
        }
        this.svgLoader();
    }
    SVGLoader.prototype.loadSpriteIcons = function () {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        requireAll(require.context("./../../icons/", true, /\.svg$/));
    };
    SVGLoader.prototype.svgSuccess = function (e) {
        var oThis = e.target;
        if (oThis.status.toString() !== "404") {
            var div = document.createElement("div");
            div.className = "svg-loader-placeholder";
            div.innerHTML = oThis.responseText;
            div.style.display = "none";
            document.body.appendChild(div);
        }
    };
    SVGLoader.prototype.svgError = function (e) {
        console.error("SVG Load Error", e);
    };
    SVGLoader.prototype.svgLoader = function () {
        var xhr = new XMLHttpRequest();
        xhr.onload = this.svgSuccess.bind(this);
        xhr.onerror = this.svgError.bind(this);
        xhr.open("get", this.svgUrl, true);
        xhr.send();
    };
    return SVGLoader;
}());
var SVGSpriteInit = {
    init: function (loadIcons) {
        if (loadIcons === void 0) { loadIcons = true; }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        var path = window.civial.path;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window.SVG = new SVGLoader("".concat(path, "/build/icons.svg"), loadIcons);
    },
};
export default SVGSpriteInit;
